import { render } from "./PixelsList.vue?vue&type=template&id=0dce58f9&scoped=true"
import script from "./PixelsList.vue?vue&type=script&lang=js"
export * from "./PixelsList.vue?vue&type=script&lang=js"

import "./PixelsList.vue?vue&type=style&index=0&id=0dce58f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dce58f9"]])

export default __exports__